module.exports = {"pageTitleText":"OWASP 规则","ruleName":"规则名称","owaspThresholdLimit":"Owasp 触发阈值","owaspParanoiaLevel":"Owasp 严谨程度","owaspDetectRules":"Owasp 探测规则"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/owasp.json
// module id = 3i0h
// module chunks = 3